export default {
  LOAD_DEPARTMENT_OVERVIEW_PAGE_START: 'LoadDepartmentOverviewPageStart',
  LOAD_DEPARTMENT_OVERVIEW_PAGE_END: 'LoadDepartmentOverviewPageEnd'
};